import { useEffect as d } from "react";
import { useLatestValue as s } from "./use-latest-value.js";

function E(n, e, a, t) {
  var i = s(a);
  d(function () {
    n = n != null ? n : window;

    function r(o) {
      i.current(o);
    }

    return n.addEventListener(e, r, t), function () {
      return n.removeEventListener(e, r, t);
    };
  }, [n, e, t]);
}

export { E as useEventListener };